import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach Bearer token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tci-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// Public
export const fetchPublications = async (params = {}) => (await api.get("/publications", { params })).data;
export const fetchInsights = async (params = {}) => (await api.get("/insights", { params })).data;
export const fetchInsight = async (slug) => (await api.get(`/insights/${slug}`)).data;
export const fetchCaseStudies = async () => (await api.get("/case-studies")).data;
export const fetchCourses = async () => (await api.get("/courses")).data;
export const fetchSectors = async () => (await api.get("/sectors")).data;
export const fetchSector = async (id) => (await api.get(`/sectors/${id}`)).data;
export const fetchGlobalNodes = async () => (await api.get("/global-nodes")).data;
export const fetchStats = async () => (await api.get("/stats")).data;
export const postNewsletter = (payload) => api.post("/newsletter", payload);
export const postContact = (payload) => api.post("/contact", payload);
export const postMembership = (payload) => api.post("/membership", payload);
export const postDemoRequest = (payload) => api.post("/demo-request", payload);
export const postCIScore = (payload) => api.post("/cleanability-index/score", payload);

// Auth
export const authRegister = (payload) => api.post("/auth/register", payload);
export const authLogin = (payload) => api.post("/auth/login", payload);
export const authLogout = () => api.post("/auth/logout");
export const authMe = () => api.get("/auth/me");

// Payments
export const createCheckoutSession = (tier, originUrl) =>
  api.post("/payments/checkout/session", { tier, origin_url: originUrl });
export const getCheckoutStatus = (sessionId) =>
  api.get(`/payments/checkout/status/${sessionId}`);

// Me
export const fetchMyPayments = () => api.get("/me/payments").then((r) => r.data);

// Admin
export const adminListUsers = () => api.get("/admin/users").then((r) => r.data);
export const adminListInquiries = () => api.get("/admin/inquiries").then((r) => r.data);
export const adminListMemberships = () => api.get("/admin/memberships").then((r) => r.data);
export const adminListPayments = () => api.get("/admin/payments").then((r) => r.data);
export const adminListNewsletter = () => api.get("/admin/newsletter").then((r) => r.data);
export const adminListDemos = () => api.get("/admin/demo-requests").then((r) => r.data);

export const adminCreatePub = (data) => api.post("/admin/publications", data);
export const adminUpdatePub = (id, data) => api.patch(`/admin/publications/${id}`, data);
export const adminDeletePub = (id) => api.delete(`/admin/publications/${id}`);

export const adminCreateInsight = (data) => api.post("/admin/insights", data);
export const adminUpdateInsight = (id, data) => api.patch(`/admin/insights/${id}`, data);
export const adminDeleteInsight = (id) => api.delete(`/admin/insights/${id}`);

export const adminCreateCase = (data) => api.post("/admin/case-studies", data);
export const adminUpdateCase = (id, data) => api.patch(`/admin/case-studies/${id}`, data);
export const adminDeleteCase = (id) => api.delete(`/admin/case-studies/${id}`);
